import { useAccountInfo } from '@/hooks/query/account';
import { SportMatchModel } from '@nf/types/odds';
import { CashoutIcon as CashoutSvgIcon } from '../svg-icons';

interface CashoutIconProps {
    match: SportMatchModel
}

export enum CashoutTypeEnum {
	All = 1,
	CreditOnly = 2,
	LicenseeOnly = 3
}

export const CashoutIcon = ({ match }: CashoutIconProps) => {
	const { user } = useAccountInfo();
	const { CO, GameID } = match;

	const hasCashout = () => {
		// user not permit to cash out
		if (user?.UserReject) {
			return false;
		} 
		// match can not cash out in licensee site
		if (!CO || ![CashoutTypeEnum.All, CashoutTypeEnum.LicenseeOnly].includes(CO)) {
			return false;
		} 
		// can not cash out with this sport type
		if (!user?.CashOutSportList || !user.CashOutSportList[GameID]) {
			return false;
		}

		return true;
	}

	return (
		hasCashout() ? (
			<div className="cashout-icon">
				<CashoutSvgIcon />
			</div>
		) : null
	);
}